"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCloseButton = exports.StyledHr = exports.StyledModalTitle = exports.StyledModalSection = exports.StyledModalContent = exports.StyledModalOverlay = void 0;
const react_1 = __importDefault(require("react"));
const Dialog = __importStar(require("@radix-ui/react-dialog"));
const styled_components_1 = __importStar(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const Button_1 = require("../Button");
const OVERLAY_BACKGROUND = (0, styled_components_1.css) `
    background: color-mix(in hsl, var(--ds-color-night) 75%, transparent);
`;
const EASE_OUT = `cubic-bezier(0.16, 1, 0.3, 1)`;
const OVERLAY_FADE_IN = (0, styled_components_1.keyframes) `
    from {
        background: transparent;
    }
    to {
        ${OVERLAY_BACKGROUND};
    }
`;
const OVERLAY_FADE_OUT = (0, styled_components_1.keyframes) `
    from {
        ${OVERLAY_BACKGROUND};
    }
    to {
        background: transparent;
    }
`;
const MODAL_SHOW = (0, styled_components_1.keyframes) `
    from {
        opacity: 0;
        transform: translateY(5px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0px) scale(1);
    }
`;
const MODAL_HIDE = (0, styled_components_1.keyframes) `
    from {
        opacity: 1;
        transform: translateY(0px) scale(1);
    }
    to {
        opacity: 0;
        transform: translateY(5px) scale(0.99);
    }
`;
exports.StyledModalOverlay = (0, styled_components_1.default)(Dialog.Overlay) `
    animation: ${OVERLAY_FADE_IN} 0.4s ${EASE_OUT};
    ${OVERLAY_BACKGROUND};
    display: grid;
    place-items: center;
    overflow-y: auto;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    z-index: 998;

    &:where([data-state="open"]) {
        animation: ${OVERLAY_FADE_IN} 400ms ${EASE_OUT};
    }
    &:where([data-state="closed"]) {
        animation: ${OVERLAY_FADE_OUT} 250ms ${EASE_OUT};
    }
`;
/**
 *
 * The reason for using `styled(({ ...props }) => <Dialog.Content aria-describedby={undefined} {...props} />)`
 * instead of `styled(Dialog.Content)` is to ensure that the `aria-describedby={undefined}` attribute
 * is passed through to `Dialog.Content`. When using `styled(Dialog.Content)`, the `aria-describedby={undefined}`
 * attribute was getting stripped out, which is why this approach was necessary.
 *
 */
exports.StyledModalContent = (0, styled_components_1.default)((_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(Dialog.Content, Object.assign({ "aria-describedby": undefined }, props)));
}) `
    background-color: var(--ds-color-white);
    border: 1px solid var(--ds-color-silver);
    border-radius: var(--ds-border-radius);
    margin: 1rem;
    width: 90vw;

    @media (min-width: ${tokens_1.BREAKPOINTS.md}) {
        width: ${({ $size }) => ($size === "large" ? 746 : 550)}px;
    }

    ${({ $fullscreen }) => $fullscreen &&
    (0, styled_components_1.css) `
            @media (max-width: ${tokens_1.BREAKPOINTS[$fullscreen]}) {
                border: none;
                border-radius: 0;
                height: 100%;
                margin: 0;
                overflow-x: hidden;
                width: 100%;
            }
        `}

    &:where([data-state="open"]) {
        animation: ${MODAL_SHOW} 0.2s ${EASE_OUT};
    }
    &:where([data-state="closed"]) {
        animation: ${MODAL_HIDE} 150ms ${EASE_OUT};
    }
`;
exports.StyledModalSection = styled_components_1.default.div `
    padding: 1rem;
`;
exports.StyledModalTitle = (0, styled_components_1.default)(Dialog.Title) `
    font-weight: 700;
    font-family: var(--ds-font-family);
    font-style: normal;
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: var(--ds-color-night);
    margin: 0;

    @media (min-width: ${tokens_1.BREAKPOINTS.md}) {
        font-size: 1.25rem;
        line-height: 2rem;
    }
`;
exports.StyledHr = styled_components_1.default.hr `
    border: 0;
    border-top: 1px solid var(--ds-color-silver);
    margin: 0;
`;
// N.B. Can't do a normal styled(Button) here as it messes with the Jest tests ¯\_(ツ)_/¯
// see https://github.com/styled-components/styled-components/issues/1449
exports.StyledCloseButton = (0, styled_components_1.default)((props) => (react_1.default.createElement(Button_1.Button, Object.assign({}, props)))) `
    align-self: self-start;
`;
//# sourceMappingURL=Modal.styles.js.map